import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { MedicationInfusionRedLabelActionV3 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-medication-infusion-red-label-slot-v3',
    templateUrl: './medication-infusion-red-label-slot-v3.component.html',
    styleUrl: './medication-infusion-red-label-slot-v3.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedicationInfusionRedLabelSlotComponentV3 implements SheetSlotComponentBase {

	action!: MedicationInfusionRedLabelActionV3;
	value!: string | null;

	@Input('action') set updateAction(action: MedicationInfusionRedLabelActionV3 | null) {
		this.action = action as MedicationInfusionRedLabelActionV3;
		this.value = this.action.dose?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}